import { CaseInfoBanner } from "src/components/case-info-banner/case-info-banner";
import { ReceivedLetter, ReceivedLetterOptions } from "src/components/received-letter/received-letter";
import { FormProvider } from "react-hook-form";
import { FormSections, useCaseFormSetup } from "src/pages/case-landing/case-form-setup";
import { useTranslation } from "react-i18next";
import { Button } from "@ucl/react-library";
import { useNavigate } from "react-router-dom";
import { useSubmitObjectionViewProps } from "src/pages/case-landing/views/submit-objection/submit-objection-view-model";
import { PortalState } from "src/api/types/enums";

const SubmitObjectionView = ({ state }: { state: PortalState }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { bannerKey } = useSubmitObjectionViewProps();

  const formSections: FormSections[] = ["receivedLetter"];
  const methods = useCaseFormSetup({ formSections, t });

  const receivedLetter = methods.watch("receivedLetter");

  const canContinue = receivedLetter === ReceivedLetterOptions.Received;

  const handleContinue = async () => {
    navigate("/challenge");
    return;
  };

  return (
    <>
      <CaseInfoBanner translationKey={`caseInfoBanner.${bannerKey}`} />
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleContinue)} className="contents">
          <ReceivedLetter showComplaint={state === PortalState.ChallengeIntent} />

          <Button type="button" disabled={!canContinue} onClick={handleContinue} fullWidth={true}>
            {t("formalObjectionEntry.startObjection")}
          </Button>
        </form>
      </FormProvider>
    </>
  );
};

export default SubmitObjectionView;
